import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { toast } from "react-toastify";
import Select from "react-select";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import {
  FaSpinner,
  FaTrash,
  FaPlus,
} from "react-icons/fa";

const AssetMaintainceListing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const passedState = location.state;

  /** =========================
   * STATES
   * ========================= */

  const [addAssetListData, setAddAssetListData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryTypeOption, setCategoryTypeOption] = useState([]);
  const [assetTypeOption, setAssetTypeOption] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [allocatedOption, setAllocatedOption] = useState([]);
  const [assetOption, setAssetOption] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [assetLoading, setAssetLoading] = useState(false);
  const [showApproveModal, setShowApproveModal] =
    useState(false);
  const [showAddModal, setShowAddModal] =
    useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [filterFormData, setFilterData] = useState([]);
  const [apiStatus, setApiStatus] = useState(undefined);

  /** =========================
   * FORM DATA
   * ========================= */

  const initialFormData = {
    MaintenanceDate: "",
    AssetID: null,
    Remarks: "",
    Location: "",
    UserName: "",
    LaptopID: "",
    ContactID: "",
    NewMaintenanceDate: "",
    // maintenanceLines: [
    //   {
    //     PreviousMaintenanceDate: "",
    //     NewMaintenanceDate: "",
    //   },
    // ],
  };

  const [formData, setFormData] =
    useState(initialFormData);

  /** =========================
   * TABLE COLUMNS
   * ========================= */

  const columns = {
    LaptopID: {
      text: "Laptop ID",
      align: "start",
      visible: true,
    },
    UserName: {
      text: "User Name",
      align: "start",
      visible: true,
    },
    MaintenanceDate: {
      text: "Maintenance Date",
      align: "start",
      visible: true,
    },
  };

  /** =========================
   * FILTERS
   * ========================= */

  const formDatas = [
    {
      name: "Asset Type",
      type: "Select",
      placeholderText: "Select",
      options: [
        { value: "", label: "Select" },
        ...assetTypeOption,
      ],
    },
    {
      name: "Category",
      type: "Select",
      placeholderText: "Select",
      options: [
        { value: "", label: "Select" },
        ...(categoryTypeOption || []),
      ],
    },
    {
      name: "Allocation Type",
      type: "Select",
      placeholderText: "Select",
      options: [
        { value: "", label: "Select" },
        ...(allocatedOption || []),
      ],
    },
  ];

  /** =========================
   * PAGE HEADING
   * ========================= */

  useEffect(() => {
    dispatch(
      updateNavbarHeading(
        `${
          passedState
            ? passedState?.text
            : "Asset Maintenance"
        }`
      )
    );
  }, [dispatch]);

  /** =========================
   * FETCH DATA
   * ========================= */

  const fetchGetAddAsset = useCallback(async () => {
    try {
      setLoading(true);

      const response = await GetServiceCaller(
        `${API_URL}asset-maintenance`
      );

      setApiStatus(response?.status);

      if (response.status === 200) {
        const cleanedData =
          response?.data?.data || [];

        const assetList = Object.entries(
          response?.data?.assetType || {}
        ).map(([key, value]) => ({
          value: parseInt(key, 10),
          label: value,
        }));

        const allocated = Object.entries(
          response?.data?.allocatedType || {}
        ).map(([key, value]) => ({
          value: parseInt(key, 10),
          label: value,
        }));

        const assetDropdown =
          response?.data?.assetList?.map(
            (ele) => ({
              value: ele?.ID,
              label: ele?.Name
            })
          ) || [];

        setAssetOption(assetDropdown);
        setAssetTypeOption(assetList);
        setAllocatedOption(allocated);
        setOriginalData(cleanedData);
        setAddAssetListData(cleanedData);
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGetAddAsset();
  }, [fetchGetAddAsset]);


  /** =========================
   * FILTER CHANGE
   * ========================= */

  const handleFilterChange = (
    e,
    name
  ) => {
    setFilterData((prevFormData) => {
      const existingIndex =
        prevFormData.findIndex(
          (item) =>
            item.label === name
        );

      if (existingIndex !== -1) {
        return prevFormData.map(
          (item) =>
            item.label === name
              ? {
                  ...item,
                  value:
                    e.value !==
                    undefined
                      ? e.value
                      : e,
                }
              : item
        );
      }

      return [
        ...prevFormData,
        {
          label: name,
          value:
            e.value !== undefined
              ? e.value
              : e,
        },
      ];
    });
  };

  /** =========================
   * OPEN MODAL
   * ========================= */

const handleAddNewAsset = () => {
  setIsEdit(false);
  setFormData(initialFormData);
  setShowAddModal(true);
};

  /** =========================
   * FORM HANDLE CHANGE
   * ========================= */

  const handleChange = (e) => {
    const { name, value } =
      e.target; 

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /** =========================
   * SELECT CHANGE
   * ========================= */

const handleSelect = async (
  selectedOption,
  name
) => {
  const assetId = selectedOption.value;

  if (!isEdit) {
    const recordExists = originalData.some(
      (item) => Number(item?.AssetID) === Number(assetId)
    );

    if (recordExists) {
      toast.warn("This asset maintenance record already exists!");
      // Reset the Asset picker selection fields back to empty states
      setFormData((prev) => ({
        ...prev,
        [name]: null,
        LaptopID: "",
        Location: "",
        UserName: "",
        ContactID: "",
      }));
      return; // Exit out of execution immediately
    }
  }

  setAssetLoading(true);

  setFormData((prev) => ({
    ...prev,
    [name]: assetId,
    LaptopID:
      selectedOption?.label || "",
  }));

  try {
    const response =
      await GetServiceCaller(
        `${API_URL}asset-details/${assetId}`
      );

    if (response.status === 200) {
      const data =
        response?.data?.assetDetails;

      setFormData((prev) => ({
        ...prev,
        AssetID: assetId,

        LaptopID:
          selectedOption?.label || "",

        Location:
          data?.Location || "",

        UserName:
          data?.UserName || "",

        ContactID:
          data?.ContactID || "",
      }));
    }
  } catch (error) {
    console.error(error);
  } finally {
    setAssetLoading(false);
  }
};

  /** =========================
   * LINE CHANGE
   * ========================= */

  const handleLineChange = (
    index,
    field,
    value
  ) => {
    const updatedLines = [
      ...formData.maintenanceLines,
    ];

    updatedLines[index][field] =
      value;

    setFormData((prev) => ({
      ...prev,
      maintenanceLines:
        updatedLines,
    }));
  };

  /** =========================
   * ADD ROW
   * ========================= */

  const addRow = () => {
    setFormData((prev) => ({
      ...prev,
      maintenanceLines: [
        ...prev.maintenanceLines,
        {
          PreviousMaintenanceDate:
            "",
          NewMaintenanceDate: "",
        },
      ],
    }));
  };

  /** =========================
   * DELETE ROW
   * ========================= */

  const deleteRow = (index) => {
    const updatedLines = [
      ...formData.maintenanceLines,
    ];

    updatedLines.splice(index, 1);

    setFormData((prev) => ({
      ...prev,
      maintenanceLines:
        updatedLines,
    }));
  };

  /** =========================
   * SUBMIT
   * ========================= */

  const handleSubmit = async (
    e
  ) => {
    e.preventDefault();
    setShowValidation(true);
    // VALIDATION
    if (!formData?.MaintenanceDate) {
      toast.error("Maintenance Date is required");
      return;
    }

    if (!formData?.AssetID) {
      toast.error("Asset is required");
      return;
    }

    try {
      setSubmitLoading(true);

      const payload = {
        ...formData,

        LaptopID:
    formData?.LaptopID || "",

        MaintenanceDate:
          formData?.MaintenanceDate &&
          moment(
            formData?.MaintenanceDate
          ).format("YYYY-MM-DD")
        // maintenanceLines:
        //   formData?.maintenanceLines?.map(
        //     (line) => ({
        //       ...line,

        //       NewMaintenanceDate:
        //         line?.NewMaintenanceDate &&
        //         moment(
        //           line?.NewMaintenanceDate
        //         ).format(
        //           "YYYY-MM-DD"
        //         ),
        //     })
        //   ),
      };

     const response =
      await PostServiceCaller(
        isEdit
          ? `${API_URL}asset-maintenance/${formData.ID}`
          : `${API_URL}asset-maintenance`,
        payload,
        isEdit ? "put" : "post"
      );

      if (response.status === 200) {
        toast.success(
          "Maintenance Added Successfully"
        );

        setShowAddModal(false);

        fetchGetAddAsset();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitLoading(false);
    }
  };

  /** =========================
   * APPROVE
   * ========================= */

const handleApproveSubmit = async () => {
  try {
    setSubmitLoading(true);
    if (
    !formData?.NewMaintenanceDate ||
  isNaN(
    new Date(formData.NewMaintenanceDate).getTime()
  )
) {
  setShowValidation(true);

  toast.error(
    "New Maintenance Date is required"
  );

  return;

}

    const payload = {
      ASMID: selectedId,

      AssetID: formData?.AssetID,

      ContactID: formData?.ContactID,

      MaintenanceDate:
        formData?.MaintenanceDate
          ? moment(
              formData.MaintenanceDate
            ).format("YYYY-MM-DD")
          : null,

      NewMaintenanceDate:
        formData?.NewMaintenanceDate
          ? moment(
              formData.NewMaintenanceDate
            ).format("YYYY-MM-DD")
          : null,
    };

    const response =
      await PostServiceCaller(
        `${API_URL}asset-log-details`,
        payload,
        "post"
      );

    if (response.status === 200) {
      toast.success(
        "Maintenance Approved Successfully"
      );

      setShowApproveModal(false);

      fetchGetAddAsset();
    }
  } catch (error) {
    console.error(error);
  } finally {
    setSubmitLoading(false);
  }
};

const handleCheckbox = (e) => {
  const { checked } = e.target;

  setFormData((prev) => ({
    ...prev,
    FinalMaintenance: checked,
  }));
};

const handleApproveClick = async (row) => {
  try {
    setSelectedId(row?.ID);

    const response = await GetServiceCaller(
      `${API_URL}asset-maintenance/${row?.ID}`
    );

    if (response.status === 200) {
      const data = response?.data?.data;

      setFormData({
        MaintenanceDate: data?.MaintenanceDate
          ? new Date(data?.MaintenanceDate)
          : null,

        AssetID: data?.AssetID || null,

        LaptopID: data?.LaptopID || "",

        Location: data?.Location || "",

        UserName: data?.UserName || "",

        Remarks: data?.Remarks || "",

        ContactID: data?.ContactID || "",

        NewMaintenanceDate:
          data?.NewMaintenanceDate
            ? new Date(data?.NewMaintenanceDate)
            : data?.MaintenanceDate
            ? moment(data?.MaintenanceDate)
                .add(1, "year")
                .toDate()
            : null,
      });

      setShowApproveModal(true);
      setShowValidation(false);
    }

  } catch (error) {
    console.error(error);
  }
};


const handleEdit = async (
  rowData
) => {
  try {
    setLoading(true);

    setIsEdit(true);

    const response =
      await GetServiceCaller(
        `${API_URL}asset-maintenance/${rowData.ID}`
      );

    if (response?.status === 200) {
      const data =
        response?.data?.data;

      setFormData({
        ID: data?.ID,

        MaintenanceDate:
          data?.MaintenanceDate || "",

        LaptopID:
          data?.LaptopID || "",

        AssetID:
          Number(data?.AssetID) ||
          null,

        ContactID:
          data?.ContactID || "",

        Location:
          data?.Location || "",

        UserName:
          data?.UserName || "",

        Remarks:
          data?.Remarks || "",
      });

      setShowAddModal(true);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  const handleApproveAction =
    useCallback(
      async (status) => {
        try {
          await PostFormServiceCaller(
            `${API_URL}assets/${selectedId}/dispose?status=${status}`,
            "post"
          );

          toast.success(
            status === 1
              ? "Approved Successfully"
              : "Rejected Successfully"
          );

          fetchGetAddAsset();
        } catch (error) {
          toast.error(
            "Something went wrong"
          );
        } finally {
          setShowApproveModal(false);
        }
      },
      [
        selectedId,
        fetchGetAddAsset,
      ]
    );

  return (
    <div
      className="container-fluid"
      id="skill_section"
    >
      <div
        className="rounded bg-white"
        id="skill-table-area"
      >
        <div className="row mt-2">
          <Dynamic_PR_table
            data={addAssetListData}
            columns={columns}
            itemsPerPage={10}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            isApiStatus={apiStatus}
            isRequiredStatus={true}
            showIcon1={false}
            showIcon2={true}
            showIcon3={true}
            isSorting={true}
            formDatas={formDatas}
            isActionRequired={true}
            isAddNewBtnRequired={true}
            handleAddNew={handleAddNewAsset}
            handleIcon2={handleApproveClick}
            handleIcon3={handleEdit}
            icons={{
              Icon2: (
                <i className="fa fa-check"></i>
              ),
              Icon2Text: "Approve",

              Icon3: (
                <i className="bi bi-pencil-square"></i>
              ),
              Icon3Text: "Edit",
            }}
          />
        </div>


{/* ADD MODAL */}

{showAddModal && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    style={{
      backgroundColor: "rgba(0,0,0,0.45)",
      zIndex: 1050,
    }}
  >
    <div
      className="modal-dialog modal-dialog-centered"
      style={{
        maxWidth: "650px",
      }}
    >
      <div
        className="modal-content border-0 shadow"
        style={{
          borderRadius: "12px",
        }}
      >
        {/* HEADER */}
        <div
          className="modal-header"
          style={{
            background: "#f8f9fa",
            borderBottom: "1px solid #e9ecef",
            padding: "14px 18px",
          }}
        >
          <h5
            className="modal-title fw-bold"
            style={{
              color: "#2E2E48",
              fontSize: "18px",
            }}
          >
           {isEdit
              ? "Update Maintenance"
              : "Add Maintenance"}
          </h5>

          <button
            type="button"
            className="btn-close"
            onClick={() =>
              setShowAddModal(false)
            }
          />
        </div>

        {/* FORM */}
        <form onSubmit={handleSubmit}>
          <div
            className="modal-body"
            style={{
              padding: "20px",
            }}
          >
            <div className="row">
              {/* Maintenance Date */}
              <div className="col-md-3 mb-3">
                <label className="form-label fw-semibold">
                  Maintenance Date <span className="text-danger">*</span>
                </label>

                <div
                  style={{
                    position: "relative",
                    zIndex: 9999,
                  }}
                >
                  <ReactDatePicker
                    selected={
                      formData.MaintenanceDate
                        ? new Date(formData.MaintenanceDate)
                        : null
                    }
                    onChange={(date) =>
                      setFormData((prev) => ({
                        ...prev,
                        MaintenanceDate: date,
                      }))
                    }
                    dateFormat="dd-MM-yyyy"
                    placeholderText="DD-MM-YYYY"
                    className={`form-control ${
                      showValidation &&
                      !formData?.MaintenanceDate
                        ? "is-invalid"
                        : ""
                    }`}
                    showPopperArrow={false}
                    popperPlacement="bottom-start"
                    autoComplete="off"
                    minDate={new Date()}
                  />

                  {showValidation &&
                    !formData?.MaintenanceDate && (
                      <div className="invalid-feedback d-block">
                        Maintenance Date is required
                      </div>
                    )}
                </div>
              </div>

              {/* Asset */}
              <div className="col-md-4 mb-3">
                <label className="form-label fw-semibold">
                  Asset <span className="text-danger">*</span>
                </label>

                <Select
                  options={assetOption}
                  name="AssetID"
                  value={assetOption.find(
                    (o) =>
                      Number(o.value) ===
                      Number(formData.AssetID)
                  )}
                  onChange={(
                    selectedOption,
                    action
                  ) =>
                    handleSelect(
                      selectedOption,
                      action.name
                    )
                  }
                  className={
                    showValidation &&
                    !formData?.AssetID
                      ? "is-invalid"
                      : ""
                  }
                />

                {showValidation &&
                  !formData?.AssetID && (
                    <div className="invalid-feedback d-block">
                      Asset is required
                    </div>
                  )}
              </div>
              {/* Location */}
              <div className="col-md-3">
                <label className="form-label">
                  Location
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={formData.Location}
                  readOnly
                />
              </div>
               {/* User Name */}
              <div className="col-md-4">
                <label className="form-label">
                  User Name
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={formData.UserName}
                  readOnly
                />
              </div>

              {/* Remarks */}
              <div className="col-md-12">
                <label className="form-label fw-semibold">
                  Remarks
                </label>

                <textarea
                  className="form-control"
                  rows={3}
                  name="Remarks"
                  value={formData.Remarks}
                  onChange={(e) =>
                    handleChange(e)
                  }
                  placeholder="Enter Remarks"
                  style={{
                    resize: "none",
                  }}
                />
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <div
            className="modal-footer"
            style={{
              borderTop:
                "1px solid #e9ecef",
              padding: "14px 18px",
            }}
          >
            <button
              type="button"
              className="btn btn-light border"
              onClick={() =>
                setShowAddModal(false)
              }
            >
              Cancel
            </button>

           <button
                type="button"
                className="btn btn-success px-4"
                onClick={handleSubmit}
                disabled={
                submitLoading ||
                assetLoading
              }
            >
              {submitLoading ? (
                <FaSpinner className="sm-spinner" />
              ) : (
                isEdit ? "Update" : "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
)}
        
        {/* APPROVE MODAL */}

{showApproveModal && (
  <div
    className="modal fade show d-block"
    style={{
      backgroundColor:
        "rgba(0,0,0,0.45)",
      zIndex: 1050,
    }}
  >
    <div
      className="modal-dialog modal-dialog-centered"
      style={{
        maxWidth: "650px",
      }}
    >
      <div
        className="modal-content border-0 shadow"
        style={{
          borderRadius: "12px",
        }}
      >
        {/* HEADER */}

        <div
          className="modal-header"
          style={{
            background: "#f8f9fa",
            borderBottom:
              "1px solid #e9ecef",
          }}
        >
          <h5 className="modal-title fw-bold">
            Maintenance Done
          </h5>

          <button
            type="button"
            className="btn-close"
            onClick={() =>
              setShowApproveModal(false)
            }
          />
        </div>

        {/* BODY */}

        <div className="modal-body">
          <div className="row">
            {/* Maintenance Date */}

            <div className="col-md-4 mb-3">
              <label className="form-label fw-semibold">
                Maintenance Date
              </label>

              <input
                type="text"
                className="form-control"
                value={
                  formData?.MaintenanceDate
                    ? moment(
                        formData.MaintenanceDate
                      ).format(
                        "DD-MM-YYYY"
                      )
                    : ""
                }
                disabled={showApproveModal}
                style={{
                backgroundColor: showApproveModal
                  ? "#e9ecef"
                  : "",
                cursor: showApproveModal
                  ? "not-allowed"
                  : "pointer",
              }}
              />
            </div>

            {/* Asset */}

            <div className="col-md-4 mb-3">
              <label className="form-label fw-semibold">
                Asset
              </label>

              <input
                type="text"
                className="form-control"
                value={
                  formData?.LaptopID || ""
                }
              style={{
                  backgroundColor: showApproveModal
                    ? "#e9ecef"
                    : "",
                  cursor: showApproveModal
                    ? "not-allowed"
                    : "pointer",
                }}
               disabled={showApproveModal}
              />
            </div>

            {/* User */}

            <div className="col-md-4 mb-3">
              <label className="form-label fw-semibold">
                User Name
              </label>

              <input
                type="text"
                className="form-control"
                value={
                  formData?.UserName || ""
                }
                disabled={showApproveModal}
                 style={{
                    backgroundColor: showApproveModal
                      ? "#e9ecef"
                      : "",
                    cursor: showApproveModal
                      ? "not-allowed"
                      : "pointer",
                  }}
              />
            </div>

            {/* NEW MAINTENANCE DATE */}

            <div className="col-md-4 mb-3">
            <label className="form-label fw-semibold">
              New Maintenance Date <span className="text-danger">*</span>
            </label>

            <ReactDatePicker
              selected={formData?.NewMaintenanceDate}
              onChange={(date) =>
                setFormData((prev) => ({
                  ...prev,
                  NewMaintenanceDate: date,
                }))
              }
              dateFormat="dd-MM-yyyy"
              className={`form-control ${
                showApproveModal &&
                showValidation &&
                !formData?.NewMaintenanceDate
                  ? "is-invalid"
                  : ""
              }`}
              placeholderText="DD-MM-YYYY"
              minDate={new Date()}
              renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
              }) => (
                <div className="d-flex justify-content-between align-items-center px-2 py-1">
                  
                  <button
                    type="button"
                    onClick={decreaseMonth}
                    className="btn btn-sm btn-light"
                  >
                    {"<"}
                  </button>

                  <div className="d-flex gap-2">
                    <select
                      value={date.getMonth()}
                      onChange={({ target: { value } }) =>
                        changeMonth(Number(value))
                      }
                      className="form-select form-select-sm"
                    >
                      {[
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                      ].map((month, index) => (
                        <option
                          key={month}
                          value={index}
                        >
                          {month}
                        </option>
                      ))}
                    </select>

                    <select
                      value={date.getFullYear()}
                      onChange={({ target: { value } }) =>
                        changeYear(Number(value))
                      }
                      className="form-select form-select-sm"
                    >
                      {Array.from(
                        { length: 100 },
                        (_, i) => 1980 + i
                      ).map((year) => (
                        <option
                          key={year}
                          value={year}
                        >
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>

                  <button
                    type="button"
                    onClick={increaseMonth}
                    className="btn btn-sm btn-light"
                  >
                    {">"}
                  </button>
                </div>
              )}
            />

            {showApproveModal &&
              showValidation &&
              !formData?.NewMaintenanceDate && (
                <div className="invalid-feedback d-block">
                  New Maintenance Date is required
                </div>
            )}
          </div>
          </div>
        </div>

        {/* FOOTER */}

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light border"
            onClick={() =>
              setShowApproveModal(false)
            }
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-success px-4"
            onClick={
              handleApproveSubmit
            }
            disabled={submitLoading}
          >
            {submitLoading ? (
              <FaSpinner className="sm-spinner" />
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default AssetMaintainceListing;